<template>
  <div id="content-wrapper">
    <b-form-group class="border-bottom-form">
      <div class="d-flex">
        <div class="flex-1-0">
          <b-form-input
            v-if="false"
            @keyup.enter="layDanhSachChucVu"
            id="filterBy"
            placeholder="Nhập từ khóa tìm kiếm"
            required
            type="text"
            v-model="requestInformation.filterBy"
          />
        </div>
        <div class="ml-1">
          <base-button
            button="Tìm kiếm"
            @click="layDanhSachChucVu()"
            v-if="false"
          />
          <base-button
            button="Import"
            @click="openImport"
            v-if="hasPermissionUser(PERMISSION_NAME.IMPORT.IMPORT_CHUC_VU)"
          />
          <base-button
            class="btn btn-blue"
            @click="openExport"
            :disabled="isLoadingExport"
            variant="info"
            v-if="hasPermissionUser(PERMISSION_NAME.IMPORT.EXPORT_CHUC_VU)"
            button="Export"
          >
          </base-button>
          <base-button
            button="Thêm mới"
            @click="openCreate"
            v-if="hasPermissionUser(PERMISSION_NAME.CHUC_VU.THEM)"
          />
        </div>
      </div>
    </b-form-group>
    <p class="color-gray-1">Tìm thấy {{ totalRows }} kết quả</p>
    <DataTable
      :loading="isLoadingTable"
      :value="items"
      dataKey="id"
      class="p-datatable-customers"
    >
      <template #empty
        ><div class="text-center">Không có dữ liệu</div></template
      >
      <template #loading
        ><div class="text-center">Đang tải dữ liệu ...</div>
      </template>
      <Column
        field="id"
        dataKey="id"
        headerStyle="width: 40px"
        headerClass="p-2"
        header="STT"
        bodyStyle="text-align: center"
      >
        <template #filter> </template>
        <template #body="slotProps">
          <span>{{
            (requestInformation.pageIndex - 1) * requestInformation.pageSize +
            slotProps.index +
            1
          }}</span>
        </template>
      </Column>
      <Column
        filterMatchMode="custom"
        field="chucVu"
        header="Chức vụ"
        headerStyle="minWidth: 200px"
      >
        <template #filter>
          <InputText
            type="text"
            class="p-column-filter"
            placeholder="Tìm kiếm"
            v-model="requestForm.ChucVuFilter"
            @change="layDanhSachChucVu"
          />
        </template>
        <template #body="slotProps">
          <span>{{ slotProps.data.chucVu }}</span>
        </template>
      </Column>
      <Column
        filterMatchMode="custom"
        field="maChucVu"
        header="Mã chức vụ"
        headerStyle="minWidth: 200px"
      >
        <template #filter>
          <InputText
            type="text"
            class="p-column-filter"
            placeholder="Tìm kiếm"
            v-model="requestForm.MaChucVuFilter"
            @change="layDanhSachChucVu"
          />
        </template>
        <template #body="slotProps">
          <span>{{ slotProps.data.maChucVu }}</span>
        </template>
      </Column>
      <Column
        filterMatchMode="custom"
        field="nhomChucVu"
        header="Tên nhóm chức vụ"
        headerStyle="minWidth: 200px"
      >
        <template #filter>
          <InputText
            type="text"
            class="p-column-filter"
            placeholder="Tìm kiếm"
            v-model="requestForm.NhomChucVuFilter"
            @change="layDanhSachChucVu"
          />
        </template>
        <template #body="slotProps">
          <span>{{ slotProps.data.nhomChucVu }}</span>
        </template>
      </Column>
      <Column
        filterMatchMode="custom"
        field="thuTu"
        header="Thứ tự"
        headerStyle="width: 120px"
      >
        <template #filter>
          <InputText
            type="text"
            class="p-column-filter"
            placeholder="Tìm kiếm"
            v-model="requestForm.ThuTuFilter"
            @change="layDanhSachChucVu"
          />
        </template>
        <template #body="slotProps">
          <div class="text-center">
            <span>{{ slotProps.data.thuTu }}</span>
          </div>
        </template>
      </Column>
      <Column
        filterMatchMode="custom"
        field="thaoTac"
        header="Thao tác"
        headerStyle="width: 100px"
        v-if="
          hasPermissionUser(PERMISSION_NAME.CHUC_VU.SUA) ||
          hasPermissionUser(PERMISSION_NAME.CHUC_VU.XOA)
        "
      >
        <template #body="slotProps">
          <div class="text-center">
            <font-awesome-icon
              icon="eye"
              v-b-popover.hover.top="'Xem chức vụ'"
              v-if="hasPermissionUser(PERMISSION_NAME.CHUC_VU.SUA)"
              class="cursor-pointer color-red mr-2"
              @click="openView(slotProps.data)"
            />
            <font-awesome-icon
              icon="edit"
              v-b-popover.hover.top="'Cập nhật chức vụ'"
              v-if="hasPermissionUser(PERMISSION_NAME.CHUC_VU.SUA)"
              class="cursor-pointer color-red"
              @click="openEdit(slotProps.data)"
            />
            <font-awesome-icon
              icon="trash-alt"
              v-b-popover.hover.top="'Xóa chức vụ'"
              v-if="hasPermissionUser(PERMISSION_NAME.CHUC_VU.XOA)"
              class="cursor-pointer color-red ml-2"
              @click="openDelete(slotProps.data)"
            />
          </div>
        </template>
      </Column>
    </DataTable>
    <BasePagination
      class="mt-3"
      :current-page="requestInformation.pageIndex"
      :total-pages="totalPages"
      :total-rows="totalRows"
      @changeNum="onChangeNum($event)"
      @changePages="onChangePages($event)"
    />

    <ModalCapNhatChucVu
      :is-view="isView"
      :data="chucVuDaChon"
      :is-edit.sync="isEdit"
      @hidden="isEdit = false"
      @refreshData="layDanhSachChucVu()"
      ref="modalCapNhatChucVu"
    />
    <ModalConfirm :title="chucVuDaChon.chucVu" @confirmed="xoaChucVu" />
    <ModalUploadImportFile
      ref="modalImport"
      :title="'Chức vụ'"
      :dataType="'ChucVu'"
      @refreshData="layDanhSachChucVu"
    />
  </div>
</template>

<script>
import BasePagination from "@/components/common/BasePagination";
import ModalCapNhatChucVu from "./modalCapNhatChucVu";
import ModalConfirm from "@/components/modal/ModalConfirm";
import ModalUploadImportFile from "@/components/modal/ModalUploadImportFile";
import {
  NO_RESULTS_TEXT,
  ROUTE_NAME,
  BANG_DM_CHUC_VU,
  PERMISSION_NAME,
} from "@/constants/constants";
import { mapGetters } from "vuex";
import { isEmpty, isNil } from "lodash";
import _cloneDeep from "lodash/cloneDeep";
import { hasPermissionUser } from "@/utils/permissionUtils";
const defaultRequestForm = {
  ChucVuFilter: "",
  MaChucVuFilter: "",
  NhomChucVuFilter: "",
};
export default {
  name: "DanhSachChucVu",
  components: {
    ModalCapNhatChucVu,
    ModalConfirm,
    BasePagination,
    ModalUploadImportFile,
  },
  data() {
    return {
      isView: false,
      isLoadingExport: false,
      PERMISSION_NAME,
      ROUTE_NAME: ROUTE_NAME,
      chucVuDaChon: {},
      isEdit: false,
      isLoadingTable: true,
      openModalDelete: false,
      items: [],
      NO_RESULTS_TEXT: NO_RESULTS_TEXT,
      requestInformation: {
        filterBy: "",
        pageSize: 10,
        pageIndex: 1,
      },
      emptyHeaderTable: [
        BANG_DM_CHUC_VU.stt,
        BANG_DM_CHUC_VU.chucVu,
        BANG_DM_CHUC_VU.nhomChucVu,
        BANG_DM_CHUC_VU.thaoTac,
      ],
      totalPages: 0,
      totalRows: 0,
      requestForm: _cloneDeep(defaultRequestForm),
    };
  },
  created() {
    if (isEmpty(this.danhSachNhomChucVu)) {
      this.$store.dispatch("nhomChucVu/layDanhSachNhomChucVu");
    }
    this.layDanhSachChucVu();
  },
  computed: {
    ...mapGetters({
      danhSachChucVu: "chucVu/danhSachChucVuPhanTrang",
      danhSachNhomChucVu: "nhomChucVu/danhSachNhomChucVu",
    }),
    hasPageData() {
      return !isEmpty(this.danhSachChucVu.items);
    },
  },
  methods: {
    hasPermissionUser,
    onChangeNum(pageSize) {
      this.requestInformation.pageIndex = 1;
      this.requestInformation.pageSize = pageSize;
      this.layDanhSachChucVu();
    },
    onChangePages(page) {
      this.requestInformation.pageIndex = page;
      this.layDanhSachChucVu();
    },
    layDanhSachChucVu() {
      this.isLoadingTable = true;
      let payload = {
        ...this.requestInformation,
        ...this.requestForm,
      };
      this.$store
        .dispatch("chucVu/layDanhSachChucVuPaging", payload)
        .then(() => {
          this.isLoadingTable = false;
        });
    },
    hienThiNhomChucVu(id) {
      const index = this.danhSachNhomChucVu.findIndex(
        (obj) => obj.id === parseInt(id)
      );
      return (
        (this.danhSachNhomChucVu[index] &&
          this.danhSachNhomChucVu[index].tenNhom) ||
        ""
      );
    },
    openImport() {
      this.$refs["modalImport"].showModal();
    },
    openExport() {
      let typeExport = "ChucVu";
      this.isLoadingExport = true;
      this.$store
        .dispatch("importService/exportData", {
          type: typeExport,
          searchRequest: {
            ...this.requestInformation,
            ...this.requestForm,
          },
        })
        .then((res) => {
          this.isLoadingExport = false;
          this.$toasted.global.showSuccessMessage({
            message: "Export thành công",
          });
          let url = window.URL.createObjectURL(new Blob([res.data]));
          let link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Export${typeExport}.xlsx`);
          document.body.appendChild(link);
          link.click();
        });
    },
    openCreate() {
      this.isView = false;
      this.isEdit = false;
      this.chucVuDaChon = {};
      this.$refs["modalCapNhatChucVu"].$refs.modalCapNhatChucVu.show();
    },
    openEdit(item) {
      this.chucVuDaChon = item;
      this.isEdit = true;
      this.isView = false;
      this.$refs["modalCapNhatChucVu"].$refs.modalCapNhatChucVu.show();
    },
    openView(item) {
      this.chucVuDaChon = item;
      this.isView = true;
      this.isEdit = false;
      this.$refs["modalCapNhatChucVu"].$refs.modalCapNhatChucVu.show();
    },
    openDelete(item) {
      this.chucVuDaChon = item;
      this.$bvModal.show("modal-confirm");
    },
    xoaChucVu(confirm) {
      if (confirm) {
        this.$store.dispatch("chucVu/xoaChucVu", {
          data: { id: this.chucVuDaChon.id },
          onSuccess: this.onSuccess,
        });
        this.$bvModal.hide("modal-confirm");
      }
    },
    onSuccess() {
      this.layDanhSachChucVu();
    },
    capNhatThuTu() {
      let listUpdate = [];
      this.items.forEach(function (item, index) {
        listUpdate.push({ Id: item.id, ThuTu: index + 1 });
      });
      let payload = new FormData();
      payload.append("arrangeRequest", JSON.stringify(listUpdate));
      this.$store.dispatch("chucVu/capNhatThuTu", {
        data: payload,
        // onSuccess: null
      });
    },
    layDanhSachChucVuNoiBo(danhSachChucVu) {
      if (isEmpty(danhSachChucVu.items)) {
        return [];
      }
      return danhSachChucVu.items.map((item, index) => {
        return {
          stt:
            (this.requestInformation.pageIndex - 1) *
              this.requestInformation.pageSize +
            index +
            1,
          chucVu: item.chucVu,
          maChucVu: item.maChucVu,
          nhomChucVu: item.nhomChucVu,
          iD_NhomChucVu: item.iD_NhomChucVu,
          id: item.id,
          thaoTac: null,
          thuTu: item.thuTu,
        };
      });
    },
  },
  watch: {
    danhSachChucVu: {
      handler() {
        this.items = this.layDanhSachChucVuNoiBo(this.danhSachChucVu);
        this.totalPages = this.danhSachChucVu.totalPage;
        this.totalRows = isNil(this.danhSachChucVu.totalCount)
          ? 0
          : this.danhSachChucVu.totalCount;
      },
    },
  },
};
</script>
